import { Model } from '@/models/Model';
export class Period extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Period';
        this.$endpoint = '/periods';
        this.$fillable = ['name', 'value', 'starts_at', 'ends_at', 'year'];
    }
    current() {
        return this.filter('current', true).first();
    }
    getFilterLabel() {
        return this.name || '';
    }
}
